// extracted by mini-css-extract-plugin
export default {"selectBlock":"group_selectBlock__Za+9p","text":"group_text__irOLB","button":"group_button__oTJDD","tableElement":"group_tableElement__n8QL9","round":"group_round__7sTBO"};